<div class="admin-content">
  <cei-admin-page-cabecalho
    titulo="Editar Permissão"
    rotaLista="/admin/permissoes"
    [rotaVoltar]="['/admin/permissoes/detalhe', registroId]"
  />
  <form #adminForm="ngForm" class="admin-form" (ngSubmit)="onSubmit(adminForm)">
    <cei-panel class="admin-form-panel" [height]="'auto'">
      <cei-input-text
        label="Nome:"
        inputId="name"
        name="name"
        required
        [(ngModel)]="form.name"
      />
      <cei-input-text
        label="Codename:"
        inputId="codename"
        name="codename"
        required
        [(ngModel)]="form.codename"
      />
    </cei-panel>
    <div class="admin-content__actions">
      <cei-button type="submit">Salvar</cei-button>
    </div>
  </form>
</div>
